import React from 'react'
import { DataBlock } from '@fs/zion-ui'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import { UserLink, PersonLink, RelationshipLink } from './Links'
import { ORIGINAL_DATE_FORMAT, timestampToDateString } from '../../util/DateUtil'
import { DmcGrid } from '../common/DmcGrid'

const wrapIt = css`
  overflow-wrap: break-word;
`

export default function JSONTable({ jsonContent }) {
  const { t } = useTranslation()

  if (jsonContent) {
    return (
      <DmcGrid columns={[5, 7]}>
        <DataBlock heading={t('json.key', 'Key')} data="" />
        <DataBlock heading={t('json.value', 'Value')} data="" />
        {Object.entries(jsonContent).map((element) => {
          const key = element[0]
          const value = element[1]
          return (
            <React.Fragment key={key + value}>
              <span css={wrapIt}>{key}</span>
              {checkValue(key, value)}
            </React.Fragment>
          )
        })}
      </DmcGrid>
    )
  }

  return null
}

function checkValue(key, value) {
  let result = null
  if (typeof value === 'boolean') {
    result = `${value}`
  }
  if (
    key === 'personId' ||
    key === 'spouse1Id' ||
    key === 'spouse2Id' ||
    key === 'husbandId' ||
    key === 'wifeId' ||
    key === 'parent1Id' ||
    key === 'parent2Id' ||
    key === 'fatherId' ||
    key === 'motherId' ||
    key === 'childId' ||
    key.toLowerCase().includes('personid')
  ) {
    if (value) {
      value = <PersonLink personId={value} showId={false} />
      result = <span css={wrapIt}>{value}</span>
    }
  } else if (
    key.toLowerCase().includes('userid') ||
    key.toLowerCase().includes('contributorid') ||
    key.toLowerCase().includes('submitterid')
  ) {
    if (value) {
      value = <UserLink userId={value} showId={false} />
      result = <span css={wrapIt}>{value}</span>
    }
  } else if (
    (key.toLowerCase().includes('timestamp') ||
      key.toLowerCase().includes('modified') ||
      key.toLowerCase().includes('created')) &&
    Number.isInteger(value)
  ) {
    value = timestampToDateString({ timestamp: value, dateFormat: ORIGINAL_DATE_FORMAT, withTime: true })
    result = <span css={wrapIt}>{value}</span>
  } else if (key.toLowerCase().includes('coupleid') && value) {
    value = <RelationshipLink relationshipId={value} relationshipType="couple" />
    result = <span css={wrapIt}>{value}</span>
  } else if (
    (key.toLowerCase().includes('parent_child_id') ||
      key.toLowerCase().includes('parentchildid') ||
      key.toLowerCase().includes('parent_childid')) &&
    value
  ) {
    value = <RelationshipLink relationshipId={value} relationshipType="parentchild" />
    result = <span css={wrapIt}>{value}</span>
  } else if (Array.isArray(value)) {
    let listStr = ''
    listStr = value.map((element) => JSON.stringify(element)).join(', ')
    result = (
      <span css={wrapIt}>
        {listStr}
        <br />
      </span>
    )
  } else if (typeof value === 'object' && value !== null) {
    result = Object.entries(value).map((element, index) => {
      const fieldKey = element[0]
      const fieldValue = element[1]

      return (
        <React.Fragment key={fieldKey + fieldValue}>
          {index === 0 && <span />}
          <span css={wrapIt}>{fieldKey}</span>
          {checkValue(fieldKey, fieldValue, true)}
        </React.Fragment>
      )
    })
  } else if (typeof value === 'string') {
    const fields = value.split('\n')
    result = <span css={wrapIt}>{fields.join(' | ')}</span>
  }
  return result || <span css={wrapIt}>{value}</span>
}
